module.exports = __webpack_public_path__ + "static/media/service-05.f424f0bc.webm";